import { AUCTION_EVENTS } from '../../event_bus_modules/auction_bidding';

$(() => {
  const notHighestBidderStcModal = $('#not-highest-bidder-stc-modal');
  const notHighestBidderSoldModal = $('#not-highest-bidder-sold-modal');
  const notHighestBidderUnsoldModal = $('#not-highest-bidder-unsold-modal');
  const highestBidderStcModal = $('#highest-bidder-stc-modal');
  const highestBidderSoldModal = $('#highest-bidder-sold-modal');
  const highestBidderUnsoldModal = $('#highest-bidder-unsold-modal');

  const isSTC = $('#_is-stc').val() === 'True';

  EVENT_BUS.on(AUCTION_EVENTS.CURRENT_USER_NOT_WON, ({ isReserveMet }) => {
    if (isSTC) {
      notHighestBidderStcModal.modal({ show: true });
    } else {
      if (isReserveMet) {
        notHighestBidderSoldModal.modal({ show: true });
      } else {
        notHighestBidderUnsoldModal.modal({ show: true });
      }
    }
  });

  EVENT_BUS.on(AUCTION_EVENTS.CURRENT_USER_WON, ({ isReserveMet }) => {
    if (isSTC) {
      highestBidderStcModal.modal({ show: true });
    } else {
      if (isReserveMet) {
        highestBidderSoldModal.modal({ show: true });
      } else {
        highestBidderUnsoldModal.modal({ show: true });
      }
    }
  });
});
